
//styles
import injectSheet from "react-jss";
import styles from './tableheader_styles';

//components
import {Title} from "@insticator/insticator-ui";


/* ========== ~~~~~~~~~~ TABLE HEADER ~~~~~~~~~~ ========== */
const TableHeader = injectSheet(styles)((props) => {

    const {actionButton, title} = props;
   return (
       <div className={`${props.classes.tableHeader} tableheader`}>
           <div className={`${props.classes.header} header`}>
               <Title>{title}</Title>
               {actionButton && actionButton}
           </div>
       </div>
   )
});

export default TableHeader;

